/** Rentman `/statuses/6` — Returned (see README) */
export const RENTMAN_STATUS_RETURNED = 6;

export function getRentmanStatusCodeFromPath(statusPath) {
  if (!statusPath || typeof statusPath !== "string") return null;
  const m = statusPath.match(/\/statuses\/(\d+)/);
  return m ? parseInt(m[1], 10) : null;
}

/** True when calendar event reflects Rentman “Returned” workflow status */
export function isRentmanReturnedEvent(ev) {
  if (!ev) return false;
  const fromField =
    ev.statusCode != null && Number(ev.statusCode) === RENTMAN_STATUS_RETURNED;
  if (fromField) return true;
  const code =
    getRentmanStatusCodeFromPath(ev.status) ??
    getRentmanStatusCodeFromPath(ev.subprojectStatus);
  return code === RENTMAN_STATUS_RETURNED;
}
